import React, { useEffect, useState } from "react";
import Image from "../Image";
import NoImage from "../../../assets/images/no-image-available.png";

const ChatImage = ({ src, alt, effect }) => {
  const [imageSrc, setImagesrc] = useState();

  useEffect(() => {
    if (src) {
      setImagesrc(src);
    }
  }, [src]);

  return (
    <div className="w-full h-full relative group">
      <a
        data-fancybox
        // {...fancyBoxType}
        href={imageSrc}
        data-preload="true"
        className="absolute top-0 left-0 w-full h-full group-hover:flex items-center justify-center rounded-md bg-black/10 hidden transition-all duration-200"
      >
        <i className="fa-solid fa-arrow-up-right-and-arrow-down-left-from-center text-white text-2xl"></i>
      </a>
      <Image
        src={imageSrc}
        alt={alt}
        effect={effect}
        onError={(e) => {
          setImagesrc(NoImage);
        }}
      />
    </div>
  );
};

export default ChatImage;
